import { SelectOption } from '../types'

export const getOptionById = <T>(
  id: string,
  options: SelectOption<T>[],
): SelectOption<T> | undefined => options.find((option: SelectOption<T>) => option.value === id)
